import { render } from "./VehicleIcon.vue?vue&type=template&id=2b931762"
import script from "./VehicleIcon.vue?vue&type=script&lang=js"
export * from "./VehicleIcon.vue?vue&type=script&lang=js"

import "./VehicleIcon.vue?vue&type=style&index=0&id=2b931762&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__